import { NodeProps } from "reactflow";
import { useEffect, useMemo, useState } from "react";

import styles from "./index.less";

import NodeCard from "../NodeCard";
import Divider from "../Divider";
import RenderInput from "../render/RenderInput";
import RenderOutput from "../render/RenderOutput";
import { RenderInputProps } from "../render/RenderInput/types";
import TextInput from "../render/RenderInput/templates/TextInput";

import { getKnowledgeFieldsService, KnowledgeField } from "../../services/app";
import { FlowModuleItemType } from "@packages/flow-core/module";
import { FlowNodeInputTypeEnum } from "@packages/flow-core/module/node/constants";
import { useFlow } from "../FlowEdit/useFlow";

// 雀鲷不支持选择知识库
const KnowledgeAll = ({ moduleId, inputs }: RenderInputProps) => {
  const { updateNodeValue } = useFlow();
  const knowledgeNameInput = useMemo(() => {
    return inputs?.find((item) => item.key === "knowledgeName");
  }, [inputs]);

  useEffect(() => {
    let totalValue: any[] = [];
    if (knowledgeNameInput?.value) {
      totalValue.push(knowledgeNameInput.value);
    }
    // if (selectedListInput?.value) {
    //   totalValue.push(...(selectedListInput.value as any[]));
    // }
    updateNodeValue(moduleId, "selectedKnowledgeAll", totalValue);
  }, [knowledgeNameInput?.value]);

  return (
    <div>
      <div className={styles["mb-7"]}>
        <TextInput
          item={knowledgeNameInput!}
          inputs={inputs}
          moduleId={moduleId}
        />
      </div>
    </div>
  );
};

export default function NodeSmartKnowledgeBase({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) {
  const [knowledgeQueries, setKnowledgeQueries] = useState<KnowledgeField[]>(
    []
  );

  const selectedKnowledge = useMemo(() => {
    return data.inputs.find((item) => item.key === "selectedList")
      ?.value as string;
  }, [data]);

  async function fetchKnowledgeQueries(baseId: string) {
    const rsp = await getKnowledgeFieldsService(baseId);
    if (rsp.data) {
      setKnowledgeQueries(rsp.data);
    }
  }

  useEffect(() => {
    if (selectedKnowledge) {
      fetchKnowledgeQueries(selectedKnowledge);
    }
  }, [selectedKnowledge]);

  return (
    <NodeCard {...data} selected={selected} minWidth={600}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput
          flowInputList={data.inputs}
          moduleId={data.moduleId}
          fieldProps={{ selectedKnowledge, knowledgeQueries }}
          CustomComponent={{
            [FlowNodeInputTypeEnum.selectedKnowledgeAll]: KnowledgeAll,
          }}
        />
      </div>
      <Divider text="输出" />
      <div className={styles.content}>
        <RenderOutput flowOutputList={data.outputs} moduleId={data.moduleId} />
      </div>
    </NodeCard>
  );
}
